/**
 * @description Checks if the user only has scopes that grant entry to the Wear
 * (DaVinci) application, meaning they should be redirected there rather than
 * into Access.
 *
 * The Wear User (72) and Wear User with MFA (73) roles each carry exactly one scope,
 * `o{orgId}-wearUser:w`. Scopes containing `user{userId}` are the user's
 * auto-assigned self-service scopes and are ignored, the same way
 * isVideoOnlyUser ignores them.
 * @param tokenScopeItem
 * @returns {boolean} True if the user has only Wear scopes, false otherwise.
 */
export const isWearOnlyUser = (
  tokenScopeItem?: Utils.ArrayElement<
    Api.Response['describeAccessToken']['tokenScopeList']
  >,
) => {
  if (!tokenScopeItem) return false;
  const { org, scope, user } = tokenScopeItem;

  const wearScopes = new Set([`o${org?.id}-wearUser:w`]);

  const userScope = `user${user?.id}`;

  const filteredScopes = scope?.filter(
    (scopeItem) => !scopeItem.includes(userScope),
  );

  return (
    (filteredScopes?.length ?? 0) > 0 &&
    filteredScopes?.every((scopeItem) => wearScopes.has(scopeItem))
  );
};
